import BaseCarousel from 'react-bootstrap/Carousel'
import React, { Component } from 'react'
import Item from './Item'
import { extendParentClass } from '../../../utils/classes'

export class Carousel extends Component {
  testimonials = [
    {
      name: 'Raihan Rafuj',
      review:
        'Awesome product. The guys have put huge effort into this app and focused on simplicity and ease of use.',
      stars: 5,
    },
    {
      name: 'Bela Bose',
      review:
        'Awesome product. The guys have put huge effort into this app and focused on simplicity and ease of use.',
      stars: 5,
    },
  ]

  baseClass = extendParentClass.bind(this)('carousel')

  state = {
    activeIndex: 0,
  }

  setActiveIndex = (activeIndex) => this.setState({ activeIndex })

  renderTestimonials = () =>
    this.testimonials.map((testimonial, index) => (
      <Item {...testimonial} key={index} parentClass={this.baseClass} />
    ))

  render() {
    return (
      <BaseCarousel
        indicators={false}
        className={this.baseClass}
        activeIndex={this.state.activeIndex}
        onSelect={this.setActiveIndex}
      >
        {this.renderTestimonials()}
      </BaseCarousel>
    )
  }
}

export default Carousel
